import { useState } from 'react'

import arrowButtonIcon from 'assets/images/explore-learnings/button-control.svg'

interface ExploreMoreSkillsProps {
  exploreMoreSkills: any[]
  getSkillObject: (skill: any) => JSX.Element
}

export const ExploreMoreSkills = ({ exploreMoreSkills, getSkillObject }: ExploreMoreSkillsProps) => {
  const [galleryPosition, setGalleryPosition] = useState(0)
  // number of cards visible at once; current design always shows 5
  const visibleCount = 5
  const maxPosition = Math.max(0, exploreMoreSkills.length - visibleCount)

  const lowerGalleryCheck = () => galleryPosition > 0
  const upperGalleryCheck = () => galleryPosition < maxPosition
  const moveGallery = (delta: number) => {
    setGalleryPosition(pos => {
      const next = pos + delta
      if (next < 0) return 0
      if (next > maxPosition) return maxPosition
      return next
    })
  }

  return (
    <div className="w-[1120px] mx-auto h-[428px] border-t border-solid border-[#D7D7D7] pt-10 overflow-hidden">
      <div className="flex justify-between mb-7">
        <p className="font-TCCC font-semibold text-2xl">Explore skills</p>
        <div className="flex">
          <img
            src={arrowButtonIcon}
            className={`rotate-180 mr-2 ${lowerGalleryCheck() ? 'cursor-pointer' : 'cursor-not-allowed opacity-40'}`}
            alt="Left"
            onClick={() => lowerGalleryCheck() && moveGallery(-1)}
          />
          <img
            src={arrowButtonIcon}
            alt="Right"
            className={`${upperGalleryCheck() ? 'cursor-pointer' : 'cursor-not-allowed opacity-40'}`}
            onClick={() => upperGalleryCheck() && moveGallery(1)}
          />
        </div>
      </div>
      <div className="relative">
        <div
          className="absolute flex gap-x-4 transition-all ease-in-out"
          style={{ left: `-${galleryPosition * 227}px` }}
        >
          {exploreMoreSkills.map((skill: any) => getSkillObject({ ...skill, banner: 0 }))}
        </div>
      </div>
    </div>
  )
}

export default ExploreMoreSkills
